import { render, staticRenderFns } from "./RenameProjectBtn.vue?vue&type=template&id=b336c5b2&scoped=true"
import script from "./RenameProjectBtn.vue?vue&type=script&lang=js"
export * from "./RenameProjectBtn.vue?vue&type=script&lang=js"
import style0 from "./RenameProjectBtn.vue?vue&type=style&index=0&id=b336c5b2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b336c5b2",
  null
  
)

export default component.exports